<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">默认值</nz-form-label>
  <nz-form-control>
    <nz-input-number
      #nameInput="ngModel"
      name="value"
      type="number"
      [nzMin]="0"
      [nzMax]="1000000000"
      [(ngModel)]="config.value"
      style="width: 100%"
    ></nz-input-number>
  </nz-form-control>
</nz-form-item>
